import {Navigate, Route, Routes} from "react-router-dom";
import {OrderRoutes} from "@/features/order";

export function AppRoutes() {
    return (
        <Routes>
            <Route path="/taxi/*" element={<OrderRoutes />} />
            <Route path="*" element={<Navigate to="/taxi" />} />
        </Routes>
    );
}
